const pageNameKey = "dashboardGraphPanelContent";

export const dashboardGraphPanelContentEn = {
  [pageNameKey]: {
    noDataMessage: "No data information available!",
  },
};

export const dashboardGraphPanelContentPtBr = {
  [pageNameKey]: {
    noDataMessage: "Nenhuma informação de dados disponível!",
  },
};

export const dashboardGraphPanelContentDe = {
  [pageNameKey]: {
    noDataMessage: "Keine Dateninformationen verfügbar!",
  },
};

export const dashboardGraphPanelContentZhHans = {
  [pageNameKey]: {
    noDataMessage: "没有可用的数据",
  },
};

export const dashboardGraphPanelContentIt = {
  [pageNameKey]: {
    noDataMessage: "Nessun dato disponibile!",
  },
};

export const dashboardGraphPanelContentEs = {
  [pageNameKey]: {
    noDataMessage: "¡No hay información de datos disponible!",
  },
};

export const dashboardGraphPanelContentNl = {
  [pageNameKey]: {
    noDataMessage: "Geen gegevensinformatie beschikbaar!",
  },
};

export const dashboardGraphPanelContentTr = {
  [pageNameKey]: {
    noDataMessage: "Veri bilgisi mevcut değil!",
  },
};
